import { render, staticRenderFns } from "./activityIntroduce.vue?vue&type=template&id=2f306d5a&scoped=true"
import script from "./activityIntroduce.vue?vue&type=script&lang=js"
export * from "./activityIntroduce.vue?vue&type=script&lang=js"
import style0 from "./activityIntroduce.vue?vue&type=style&index=0&id=2f306d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f306d5a",
  null
  
)

export default component.exports